
import React from "react";
import { Box, Typography, Paper, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import dayjs from "dayjs";

function TimesListView({ times, selectedTimeIndex, onDelete, onSelect, onAddTime }) {
  const formatTimeRange = (time) => {
    if (Array.isArray(time.from)) {
      return `${dayjs(time.from[0]).format("HH:mm")} - ${dayjs(time.to[0]).format("HH:mm")}`;
   
    } else if (typeof time.from === "string") {
      return `${time.from} - ${time.to}`;
    }


  };
  return (
    <Box p={3}>
      <Typography textAlign="center" variant="h4">Times</Typography>
      {times.map((time, index) => (
        <Paper
          key={index}
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            mt: 2,
            cursor: "pointer",
            backgroundColor: index === selectedTimeIndex ? "#E42A78" : "#1A2035", // Highlight selected item
            border: index === selectedTimeIndex ? "2px solid #E42A78" : "1px solid lightgray", // Adds border to selected item
          }}
          onClick={() => onSelect(index)}
        >
          <Box>
            <Typography variant="body1" style={{color:"white"}}>
              {time.allDay
                ? "All day"
                : formatTimeRange(time)}
            </Typography>
          </Box>
          <Box>
            <IconButton
              color="info"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(index);
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        </Paper>
      ))}
      <MDButton variant="contained" color="info" size="medium"  sx={{ mt: 5, ml:9 }} onClick={onAddTime}>
        <Icon>add</Icon>&nbsp;Add new time range
      </MDButton>
    </Box>
  );
}

export default TimesListView;
